var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message",class:[_vm.type],style:(_vm.positionStyle)},[_c('div',{staticClass:"message-outer"},[_c('span',{staticClass:"message__icon"},[_c('i',{class:[`el-icon-${_vm.type}`, `message__icon--${_vm.type}`]})]),_c('div',{staticClass:"message-inner"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }